import { values } from 'lodash';
import React, { Component } from 'react';
import Select from 'react-select';

export default class ItemFormCustomSelect extends Component {
  handleChange = values => {
    let value;
    if (values instanceof Array || this.props.isMulti) {
      value = values
        ? values.map(val => {
            return val.value;
          })
        : [];

      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    } else {
      value = values.value;
      if (this.props.onChangeValue) {
        this.props.onChangeValue([this.props.name], value);
      }
    }
    this.props.onChange(this.props.name, value);
  };

  handleBlur = () => {
    this.props.onBlur([this.props.name], true);
  };

  render() {
    console.log('In Item custom select::', this.props);
    const { name, options, value, placeholder, isMulti } = this.props;
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: '#e3edff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#2684FF'
            : isFocused
            ? '#2684FF9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#e3edff' : '#2684FF'),
          },
        };
      },
    };

    const valuesList = value
      ? Array.isArray(value)
        ? options.filter(option => value.includes(option.value))
        : options.filter(option => value.toString() === option.value.toString())
      : [];
    console.log('valuesListvaluesListvaluesListvaluesListvaluesList', valuesList);
    return (
      <Select
        name={name}
        isMulti={isMulti}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        value={valuesList}
        placeholder={placeholder}
        onChange={this.handleChange}
        styles={colourStyles}
      />
    );
  }
}
